export default __webpack_public_path__ + "static/media/Promo1.82e824f0.jpeg";